import { Injectable } from '@angular/core';
import { EndpointOptions } from './endpoint.service';
import { Headers, RequestOptionsArgs, ResponseContentType } from '@angular/http';
import { StateService } from '../state/state.service';

@Injectable()
export class NativeOptionsBuilder {
  constructor(private state: StateService) {
  }

  build<T>(options: EndpointOptions): RequestOptionsArgs {
    const nativeOptions: RequestOptionsArgs = {
      headers: new Headers(),
    };
    if (options.secure) {
      const token = this.state.snapshot.auth.idToken;
      nativeOptions.headers.set('Authorization', `Bearer ${token}`);
    }
    if (options.resource) {
      nativeOptions.responseType = ResponseContentType.Blob;
    }
    if (options.myfoglioAuth !== null && options.myfoglioAuth !== undefined) {
      //nativeOptions.headers.set('User-Agent', 'Fiddler');
      nativeOptions.headers.set('Content-Type', 'application/x-www-form-urlencoded');
      nativeOptions.headers.set('Accept', 'application/vnd.myfoglio.v1+json');
      nativeOptions.headers.set('Authorization', options.myfoglioAuth);
      //nativeOptions.headers.set('Host', "api.myfoglio.com");
    }
    if (options.myfoglioJwt !== null && options.myfoglioJwt !== undefined) {
      //nativeOptions.headers.set('User-Agent', 'Fiddler');
      nativeOptions.headers.set('Content-Type', 'application/json');
      nativeOptions.headers.set('Accept', 'application/vnd.myfoglio.v1+json');
      nativeOptions.headers.set('Authorization', options.myfoglioJwt);
      //nativeOptions.headers.set('Host', "api.myfoglio.com");
    }

    return nativeOptions;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/native-options-builder.ts